<script setup>
await navigateTo("/", { replace: true });
</script>

<template>
  <div />
</template>
